/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { OsanoCMP, OsanoSetter } from '../types/osano';

declare global {
  interface Window {
    Osano?: OsanoSetter & OsanoCMP;
  }
}

type OsanoAction = (osano: OsanoSetter & OsanoCMP) => void;

type OsanoEventCallbacks = {
  acceptCallback: (...args: unknown[]) => void;
  denyCallback: (...args: unknown[]) => void;
};

const executeOsanoAction = (action: OsanoAction) => {
  if (window.Osano) {
    action(window.Osano);
  }
};

export const addOsanoListeners = ({ acceptCallback, denyCallback }: OsanoEventCallbacks) => {
  executeOsanoAction((osano) => {
    osano.cm.addEventListener('osano-cm-consent-saved', (consent) => {
      if (consent['ANALYTICS'] === 'ACCEPT') {
        acceptCallback();
      }
      if (consent['ANALYTICS'] === 'DENY') {
        denyCallback();
      }
    });
  });
};

export const removeOsanoListeners = () => {
  executeOsanoAction((osano) => {
    osano.cm.removeEventListener('osano-cm-consent-saved', () => {});
  });
};

export const setOsanoLocale = (locale: string) => {
  executeOsanoAction((osano) => {
    osano('locale', locale);
  });
};
